<template>
	<div class="content">
		<div class="row">
			<div class="col-md-12">
				<div id="paso1" class="accion" v-on:click="retroceder(1)">
					<div v-if="paso == 1" class="verde">1</div>
					<div v-if="paso > 1" class="verde-opaco">1</div>
					<div :class="paso != 1 ? 'oculto' : 'flecha'"></div>
				</div>
				<div class="linea"></div>
				<div id="paso2" :class="this.archivos.length == N && paso != 2 ? 'accion confirma' : 'accion'" v-on="this.archivos.length == N && paso != 2 ? { click: () => fin(2) } : ''">
					<div v-if="paso == 2" class="verde">FIN</div>
					<div v-if="paso < 2" class="celeste">FIN</div>
					<div v-if="paso > 2" class="verde-opaco">FIN</div>
					<div :class="paso != 2 ? 'oculto' : 'flecha'"></div>
				</div>
			</div>
		</div>
		<paso-1 v-if="paso == 1" :on-periodo="onPeriodo" :on-avanzar="onAvanzar" :on-archivo="onArchivo"></paso-1>
		<paso-2 v-if="paso == 2" :periodo="periodo" :archivos="archivos" :confirmacion="confirmacion"></paso-2>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import Paso1 from "./paso1.vue"
	import Paso2 from "./paso2.vue"


	export default {
		name: "Carga15Dias",
		components: { Paso1, Paso2 },
		data() {
			return {
				periodo: "",
				paso: 1,
				N: 1, // Cantidad total de archivos que se deben subir
				archivos: [], // Lista de archivos cargados. Cada paso informa mediante una funcion del callback el archivo a monitorear
				checker: null, // Variable que guarda la instancia del proceso que monitorea el avance de los archivos. Se usa para poder detenerlo
				inicia: false, // Flag que controla el inicio del monitor de progreso
				confirmacion: false // Si todos los archivos llegan al 100%, se avisa al paso8 para que active el boton CONFIRMACION
			}
		},
		beforeDestroy() {

			// Si se destruye el componente, finalizamos el proceso de monitoreo, si es que se inicio antes
			if (this.inicia)
				clearInterval(this.checker)
		},
		methods: {

			// Funcion que permite retroceder a los pasos previos al paso actual
			retroceder(paso) {

				// Solo se puede ir a pasos anteriores
				if (paso >= this.paso)
					return

				this.paso = paso
			},

			// Para avanzar al paso final, solo cuando se hayan cargado todos los archivos
			fin(paso) {

				if (this.archivos.length < this.N)
					return	

				this.paso = paso
			},

			// Funcion que monitorea el avance de carga de los archivos, preguntado al servidor a traves de la API
			progreso() {

				// Recorremos la lista de archivos para actualizar el avance de la carga
				for (var idx in this.archivos)
				{
					var archivo = this.archivos[idx]

					// Si el archivo ya alcanzo el 100%, lo saltamos
					if (archivo.avance == 100)
					{
						continue
					}

					// Actualizamos el avance de la carga a través de la api
					this.getEstadoCarga(idx)
				}
 
				// Recorremos la lista de archivos para contar cuantos han finalizado (alcanzado el 100%)
				var finalizados = 0
				for (var idx in this.archivos)
				{
					if (this.archivos[idx].avance == 100)
						finalizados++
				}

				// Si todos los archivos alcanzaron el 100%, detenemos el proceso que monitorea el avance
				if (finalizados == this.archivos.length) {

					// Cambiamos INICIA a false por si se devuelve a algun paso anterior, para iniciar el monitor nuevamente 
					this.inicia = false
					// Mediante esta variable, informamos al paso 8 que todos los archivos ya estan en un 100%, para que active el boton CONFIRMAR
					// Se hace aqui para no iniciar un proceso en el paso 8 que revise el avance de los archivos
					this.confirmacion = true

					// Detenemos el monitor 
					clearInterval(this.checker)
				} else
					this.confirmacion = false
			},

			// Revisa el estado de avance de la carga de archivos en el servidor, llamando a la API
			getEstadoCarga(idx) {

				var request = {
					"usuario": this.$usuario,
					"destino": this.$env, 
					"tx": "D0",
					"operacion": "EstadoArchivos",
					"data2Query": {
						"archivo": this.archivos[idx].archivo, 
						"periodo": this.periodo
					}
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => { 
	
					if (response.data.progreso != undefined) {

						var archivo = this.archivos[idx]
						archivo.avance = response.data.progreso.replace("%", "")
						this.$set(this.archivos, idx, archivo) 
					} else
						console.log(response.data)
				})
			},

			// Actualiza el periodo para enviarlo a los demas pasos
			// El periodo solo se cambia en el paso 1
			onPeriodo(periodo) {

				this.periodo = periodo
			},

			// Funcion callback que se llamada cada vez que se avanza un paso
			onAvanzar() {

				this.paso++
			},

			// Funcion callback que se llama cada vez que se sube un archivo
			// Esta funcion agrega el archivo informado a la lista de archivos para incluirlo en el monitor 
			onArchivo(data) {

				// Recorremos la lista de archivos, para saber si el que enviaron ya existe en la lista
				var idx = -1
				this.archivos.forEach(function(archivo, i) {

						if (archivo.archivo == data.archivo)
						{
							idx = i
							return false
						}
				})

				// Si el archivo ya existe, lo reemplazamos, sino, lo agregamos
				if (idx > -1)
					this.archivos[idx] = data
				else
					this.archivos.push(data)

				// Si hay archivos cargados y no se ha iniciado el monitor del estado de carga, lo iniciamos
				// Se va a consultar cada 5 segundos al servidor
				if (this.archivos.length > 0 && !this.inicia)
				{
					this.inicia = true
					this.checker = setInterval(this.progreso, 5000)
				}
			}
		}
	}

</script>
<style scoped>

	.content {
		width: 100%;
		padding: 0px 15px 5px 15px;
	}

	.accion {
		float: left;
	}

	.confirma:hover {
		cursor: pointer;
	}

	.verde {
		background: green;
		border-radius: 50%;
		width: 45px;
		text-align: center;
		color: white;
		padding: 5px;
		font-size: 22px;
	}

	.verde-opaco {
		background: #4286436b;
		border-radius: 50%;
		width: 45px;
		text-align: center;
		color: white;
		padding: 5px;
		font-size: 22px;
	}

	.verde-opaco:hover {
		cursor: pointer;
	}

	.celeste {
		background: #337ab7;
		border-radius: 50%;
		width: 45px;
		text-align: center;
		color: white;
		padding: 5px;
		font-size: 22px;
	}

	.linea {
		float: left;
		border-bottom: solid green 2px;
		width: 32px;
		margin-top: 20px;
	}

	.flecha {
		float: left;
		border-left: 20px solid transparent;
		border-right: 20px solid transparent;
		border-bottom: 20px solid #3c763d;
		/*top: 44px;*/
		position: absolute;
		margin-left: 3px;
	}

	.oculto {
		display: none;
	}

</style>
